import { compose, get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { composeProps, createPropsExtender, createReducer, createAction } from '@mews/framework';
import moduleSelector from '../selector';
import prefix from '../prefix';
import { getServiceTimeUnit } from './services';

export const NAME = 'serviceSelection';

export const SELECT_SERVICE = prefix('SELECT_SERVICE');

export const changeServiceId = (serviceId: string) => createAction(SELECT_SERVICE, { serviceId });

export const serviceSelectReducer = createReducer(
    { selectedServiceId: null },
    {
        // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
        [SELECT_SERVICE]: (state, { serviceId }: $TSFixMe) => ({
            ...state,
            selectedServiceId: serviceId,
        }),
    }
);

const getServiceSelection = compose(get(NAME), moduleSelector);

export const getSelectedServiceId = createSelector(getServiceSelection, get('selectedServiceId'));

export const getSelectedServiceTimeUnit = composeProps(
    getServiceTimeUnit,
    createPropsExtender('id', getSelectedServiceId)
);
